import Authorize from '../Api/Auth/Authorize';
import LoginCallback from '../Api/Auth/LoginCallback';
import LoginChecker from '../Api/Auth/LoginChecker';

const authRoutes = [
  {
    id: 1,
    type: "function",
    path: '/login',
    component: LoginChecker, 
  },
  {
    id: 2,
    type: "function",
    path: '/callback',
    component: LoginCallback,
  },
  {
    id: 3,
    type: "function",
    path: '/authorize',
    component: Authorize,
  }
];

export default authRoutes;